import { css } from 'styled-components';
import { ActionLinkStyle } from '../../../../components/DocumentDownloadLink/styles';
import { colors, themeSpecificColors } from '../../colors';

export default css`
  &${ActionLinkStyle} {
    &:link {
      color: ${colors.core01};
    }

    &:visited {
      color: ${themeSpecificColors.limbo01};
    }

    margin: 0;
  }
`;
